import { AuthConfigMap } from '../models/AuthenticationModel';
import { EnvironmentConfigMap } from '../models/EnvironmentConfigMapModel';


export const COPYRIGHT = '© Siemens 2022-2023';



export const FEATURE_AUDIT_ADMIN = 'siak-feature-audit-admin';
export const FEATURE_AUDIT_GROUP = 'siak-feature-audit-group';
export const FEATURE_AUDIT_SEARCH = 'siak-feature-audit-search';

export const AUTH_ENDPOINT =
  'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a/v2.0';
export const AUTH_ENDPOINT_INTEGRATION =
  'http://oidc-server-mock:4011/oidc-test';
export const AUTH_CONFIG_MAP_DEFAULT = 'fc50a5e6-f9ad-4bcc-9414-e2a71d2b4c71';
export const AUTH_CONFIG_MAP: AuthConfigMap = {
  'devportal.dsc.local': 'fc50a5e6-f9ad-4bcc-9414-e2a71d2b4c71'
};
